import { render, staticRenderFns } from "./DemandProjectAnnounce.vue?vue&type=template&id=d8d98ef4&scoped=true&"
import script from "./DemandProjectAnnounce.vue?vue&type=script&lang=js&"
export * from "./DemandProjectAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./DemandProjectAnnounce.vue?vue&type=style&index=0&id=d8d98ef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d98ef4",
  null
  
)

export default component.exports